// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".new-navbar-user-menu[data-v-1318d0e4]{border-radius:1.6rem;right:3%;width:-webkit-min-content;width:-moz-min-content;width:min-content;top:6rem}.fade-enter-active[data-v-1318d0e4],.fade-leave-active[data-v-1318d0e4]{transition:opacity .5s}.fade-enter[data-v-1318d0e4],.fade-leave-to[data-v-1318d0e4]{opacity:0}a[data-v-1318d0e4]{white-space:nowrap}@media (min-width:1024px){.new-navbar-user-menu[data-v-1318d0e4]{top:8rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
